(function () {
  const c = document.createElement("link").relList;
  if (c && c.supports && c.supports("modulepreload")) return;
  for (const i of document.querySelectorAll('link[rel="modulepreload"]')) n(i);
  new MutationObserver((i) => {
    for (const o of i)
      if (o.type === "childList")
        for (const a of o.addedNodes)
          a.tagName === "LINK" && a.rel === "modulepreload" && n(a);
  }).observe(document, { childList: !0, subtree: !0 });
  function f(i) {
    const o = {};
    return (
      i.integrity && (o.integrity = i.integrity),
      i.referrerpolicy && (o.referrerPolicy = i.referrerpolicy),
      i.crossorigin === "use-credentials"
        ? (o.credentials = "include")
        : i.crossorigin === "anonymous"
        ? (o.credentials = "omit")
        : (o.credentials = "same-origin"),
      o
    );
  }
  function n(i) {
    if (i.ep) return;
    i.ep = !0;
    const o = f(i);
    fetch(i.href, o);
  }
})();
function V() {
  const u = new Intl.NumberFormat(Shopify.locale, {
    style: "currency",
    currency: Shopify.currency.active,
  });
  function c(e, t) {
    return (e.innerHTML =
      '<span class="money">' + u.format(t / 100) + "</span>");
  }
  function f(e) {
    return e.reduce((t, l) => [...t, ...l.selling_plans], []);
  }
  function n(e, t) {
    return e.selling_plan_allocations.find(
      (l) => l.selling_plan_id === Number(t)
    );
  }
  function i(e) {
    return e.reduce((t, l) => {
      const { price_adjustments: s } = l,
        r = s.find(({ value_type: d }) => d === "percentage");
      return r == null ? t : r.value > t ? r.value : t;
    }, 0);
  }
  function o(e, t) {
    return (
      e.filter((s) => {
        const { price_adjustments: r } = s,
          d = r.find(({ value_type: S }) => S === "percentage");
        return d == null ? !1 : Number(d.value) === t;
      }).length === e.length
    );
  }
  function a(e) {
    let t = e.querySelector('inpu[name="selling_plan"]');
    return (
      t ||
        ((t = document.createElement("input")),
        (t.type = "hidden"),
        (t.name = "selling_plan"),
        e.append(t)),
      t
    );
  }
  function y(e, t) {
    const l = document.querySelector('form[action$="/cart/add"]'),
      s = a(l),
      r = document.querySelector("#juo-subscription-widget"),
      d = r.querySelector('[data-ref="price"]'),
      S = r.querySelector('[data-ref="base-price"]'),
      q = r.querySelector('[data-ref="compare-price"]'),
      g = r.querySelector('[data-ref="save"]'),
      b = r.querySelector('[data-ref="selling-plan"]');
    function C() {
      return r.querySelector('input[name="mode"]:checked').value;
    }
    function w() {
      return C() === "otp" ? "" : r.querySelector("select").value;
    }
    function P() {
      s.value = w();
    }
    function I() {
      const p = new URL(window.location.href).searchParams.get("variant");
      return t[p] || Object.values(t).find(Boolean);
    }
    function F() {
      const m = I(),
        p = n(m, b.value),
        L = m.selling_plan_allocations.map((N) =>
          e.find((O) => O.id === N.selling_plan_id)
        ),
        h = i(L);
      o(L, h)
        ? h > 0
          ? (g.textContent = "Save " + h + "%")
          : (g.textContent = "")
        : (g.textContent = "Save up to " + h + "%"),
        g.textContent.length === 0 && (g.parentElement.style.display = "none"),
        c(S, m.price),
        c(d, p.price),
        p.price < p.compare_at_price
          ? c(q, p.compare_at_price)
          : (q.textContent = "");
    }
    function v() {
      P(), F();
    }
    v(),
      r.addEventListener("change", v),
      l.addEventListener("change", v),
      b.addEventListener("change", () => {
        r.querySelector('input[name="mode"][value="subscription"]').click();
      });
  }
  if (window.Shopify != null) {
    let e = function () {
      const t = document.getElementById("selling-plans-data");
      if (t == null) return;
      const l = JSON.parse(t.textContent);
      if (l.selling_plan_groups.length === 0) return;
      const s = f(l.selling_plan_groups);
      y(s, l.variants);
    };
    var _ = e;
    document.readyState === "complete" ||
    document.readyState === "loaded" ||
    document.readyState === "interactive"
      ? e()
      : document.addEventListener("DOMContentLoaded", e);
  }
}
function x() {
  const u = document.querySelector("#juo-subscription-widget"),
    c = document.querySelector(".subscription"),
    f = document.querySelector(".otp"),
    n = u?.querySelector(".subscription-details");
  function i() {
    return (
      u.querySelector('input[name="mode"]:checked').value === "subscription"
    );
  }
  let o = i();
  (n.style.height = o ? "auto" : "0"), (n.style.overflow = "hidden");
  function a() {
    const e = getComputedStyle(n).height;
    n.style.height = "auto";
    const t = getComputedStyle(n).height;
    (n.style.height = e),
      getComputedStyle(n).height,
      requestAnimationFrame(function () {
        n.style.height = t;
      });
  }
  function y() {
    const e = getComputedStyle(n).height;
    (n.style.height = e),
      getComputedStyle(n).height,
      requestAnimationFrame(function () {
        n.style.height = "0";
      });
  }
  function _() {
    const e = i();
    c.classList[e ? "add" : "remove"]("active"),
      f.classList[e ? "remove" : "add"]("active"),
      e !== o && ((o = e), e ? a() : y());
  }
  (n.style.transition = "height 300ms ease-in-out"),
    _(),
    u.addEventListener("change", _),
    n.addEventListener("transitionend", function () {
      Number.parseFloat(n.style.height) > 0.1 && (n.style.height = "auto");
    });
}
function E() {
  try {
    V(), x();
  } catch (e) {}
}
document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", E)
  : E();
